/**
 * Service Layer para API de Plans Upgrade
 * Base path: /plans/v1/{vehicleType}/upgrade
 *
 * Co-localizado com hooks seguindo arquitetura ANCR-FA.
 * Zero lógica de negócio — puro HTTP.
 */

import { httpClient } from '@/services/api';
import type {
	TVehicleType,
	TUpgradeModality,
	TUpgradeModalityDetail
} from './plans-upgrade.types';

const getBaseUrl = (vehicleType: TVehicleType): string => {
	return `plans/v1/${vehicleType}/upgrade`;
};

const plansUpgradeService = {
	/**
	 * GET /plans/v1/{vehicleType}/upgrade
	 * Lista modalidades de upgrade disponíveis
	 */
	listUpgradeModalities: async (
		vehicleType: TVehicleType,
		advertiseId: number
	): Promise<TUpgradeModality[]> => {
		const { data } = await httpClient.get<{ data: TUpgradeModality[] }>(getBaseUrl(vehicleType), {
			params: { advertiseId }
		});
		return data.data;
	},

	/**
	 * GET /plans/v1/{vehicleType}/upgrade/{modalityId}
	 * Busca detalhes de uma modalidade específica
	 */
	getUpgradeModality: async (
		vehicleType: TVehicleType,
		modalityId: string,
		advertiseId: number
	): Promise<TUpgradeModalityDetail> => {
		const { data } = await httpClient.get<{ data: TUpgradeModalityDetail }>(
			`${getBaseUrl(vehicleType)}/${modalityId}`,
			{ params: { advertiseId } }
		);
		return data.data;
	}
};

export { plansUpgradeService };
